module.exports = {
  maxWidth: 400,
  minWidth: 20,
  minHeight: 32,
  maxHeight: 200,
  mathInputMaxHeight: 64,
  expectedAnsMinHeight: 35,
  minWidthShowAnswer: 111,
  indexSizeSmallBox: 10,
  clozeTextMaxWidth: 600,
  popoverMaxWidth: 400,
  v1DocBased: {
    width: 712,
    height: 792,
  },
}
